import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { getLocalStorage } from '@/utils/localStorage';
import AppRoutes from '@/const/routes';
import { customEvent } from '@/lib';
import { StatusCaseItem } from '@/interfaces';

interface Props {
	id: string;
	status?: StatusCaseItem;
}

export const useCaseApply = ({ id, status }: Props) => {
	const session = useSession();
	const router = useRouter();
	const { pathname } = router;

	const handleClick = async () => {
		if (session.data?.user?.user.role === 'lawyer') {
			handleRedirectLawyer();
			return;
		}
		if (status === 'Open to new clients') {
			const userId = session.data?.user?.user.id || getLocalStorage('user_id');
			// setLocalStorage('case_id', id);

			if (userId) {
				if (pathname.includes(AppRoutes.CLIENTAPP)) {
					router.push(`${AppRoutes.CLIENTAPP_ALL_CASES_FILE_YOUR_CLAIM}/${id}`);
				} else {
					router.push(`${AppRoutes.LANDING_FILE_YOUR_CLAIM}/${id}`);
				}
			} else {
				customEvent({
					action: 'sign_up_click',
					category: 'landing',
					label: 'Sign-up',
					value: 'Sign-up',
					callback: () =>
						window.open(
							`${AppRoutes.CLIENTAPP_AUTH_SIGN_UP}?case=${id}`,
							'_blank'
						),
				});
			}
		} else {
			if (pathname.includes(AppRoutes.CLIENTAPP)) {
				router.push(`${AppRoutes.CLIENTAPP_ALL_CASES}`);
			} else {
				router.push(`${AppRoutes.LANDING_CASES}`);
			}
		}
	};

	const handleRedirectLawyer = async () => {
		if (status === 'Open to new clients') {
			await customEvent({
				action: 'sign_up_click',
				category: 'landing',
				label: 'Sign-up',
				value: 'Sign-up',
				callback: async () => {
					window.open(AppRoutes.CLIENTAPP_AUTH_SIGN_UP, '_blank');
				},
			});
		} else {
			router.push(`${AppRoutes.LANDING_CASES}`);
		}
	};

	return {
		handleClick,
	};
};
